import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { routes } from './app.routes';
//import { authInterceptor } from './interceptors/auth.interceptor';
import { authTokenInterceptor } from './interceptors/authToken.interceptor';
import { TranslationService } from './services/translation.service';

export const appConfig: ApplicationConfig = {
  // providers: [
  //   provideZoneChangeDetection({ eventCoalescing: true }),
  //   provideRouter(routes),
    // provideHttpClient(withInterceptors([authTokenInterceptor, authInterceptor])),
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: (translations: TranslationService) => () => firstValueFrom(translations.initialize()),
    //   deps: [TranslationService],
    //   multi: true
    // }
  //]

    providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authTokenInterceptor])),
    {
      provide: APP_INITIALIZER,
      useFactory: (translations: TranslationService) => () => firstValueFrom(translations.initialize()),
      deps: [TranslationService],
      multi: true
    }
  ]
};
